import get from 'lodash/get';
import flow from 'lodash/flow';
import createSelector from '@configuratorware/configurator-frontendgui/Utils/Function/createSelector';

export const getCustomConfigurator = (rootState) => rootState.customConfigurator;

export const getSortedPmsAmounts = (state) => get(state, 'customConfigurator.sortedPmsAmounts');
export const getSurcharge = (state) => get(state, 'customConfigurator.surcharges');
export const _getSortedPmsAmounts = createSelector(
  getCustomConfigurator,
  (customConfigurator) => get(customConfigurator, 'sortedPmsAmounts'),
);
export const getMaxAmount = (state) => get(state, 'customConfigurator.maxAmount');
